<template>
  <modal>
    <template slot="modal-header">
      <div class="header-wrapper">
        <h2 class="section-heading">
          <template v-if="packageId"
            >Edit package</template
          >
          <template v-else
            >Create new package</template
          >
        </h2>
        <close-button @closeModal="closeModal"></close-button>
      </div>
    </template>
    <template slot="modal-body">
      <vue-form :state="formState" @submit.prevent="">
        <validate class="form-group col-12 c__modal--title c__editable">
          <field-messages class="invalid-feedback" name="title" show="$dirty && $invalid">
            <div slot="required">Package name is required</div>
          </field-messages>
          <input
            type="text"
            required
            name="title"
            class="input-title"
            placeholder="Package Name"
            v-model="product.title"
          />
          <div class="i__edit">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 53.3 53.3"
              style="enable-background:new 0 0 53.3 53.3;"
              xml:space="preserve"
            >
              <path
                d="M51.7,14.7L38.6,1.6c-0.8-0.8-2.2-0.8-3,0l-34,34C1.2,36,1,36.5,1,37.1v13.1c0,1.2,1,2.1,2.1,2.1h13.1
                                c0.6,0,1.1-0.2,1.5-0.6l34-34C52.5,16.9,52.5,15.5,51.7,14.7z M15.3,48h-10V38l2.2-2.2l10,10L15.3,48z M20.5,42.8l-10-10L37.1,6.2
                                l10,10L20.5,42.8z"
              />
            </svg>
          </div>
        </validate>
        <tabs
          :tabs="tabs"
          :currentTab="currentTab"
          :wrapper-class="'tabs'"
          :tab-class="'tab-item'"
          :tab-active-class="'active'"
          :line-class="'tab-active-line'"
          @onClick="changeTab"
        />
        <div class="tab-content">
          <div v-if="currentTab === 'tab1'">
            <div class="form-row">
              <div class="col-12">
                <div class="form-row">
                  <div class="form-group col-12">
                    <div class="c__checkbox inline">
                      <input type="radio" value="office" v-model="product.type" />
                      <label class="round" for="office">Office Package</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input type="radio" value="agent" v-model="product.type" />
                      <label class="round" for="agent">Agent Package</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input type="radio" value="agent extend" v-model="product.type" />
                      <label class="round" for="agent extend">agent extend Package</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input type="radio" value="property" v-model="product.type" />
                      <label class="round" for="property">Property Package</label>
                    </div>
                    <label style="margin-bottom:10px">Package Type</label>
                  </div>
                  <div class="form-group col-12">
                    <div class="c__checkbox inline">
                      <input
                        type="checkbox"
                        name=""
                        value="1"
                        class="form-control"
                        v-model="product.enableJustSold"
                        :disabled="product.type !== 'property'"
                      />
                      <label class="">Enable Just Sold</label>
                    </div>
                  </div>
                </div>
                <div
                  class="form-row"
                  v-if="product.type == 'property' || product.type == 'agent extend'"
                >
                  <div class="form-group col-12">
                    <input
                      type="text"
                      class="form-control"
                      :readonly="!$isAllowed('changePackageId')"
                      v-model="product.propertyPackageId"
                    />
                    <label>Property Package ID</label>
                  </div>
                </div>
                <div
                  class="form-row"
                  v-if="product.type == 'agent' || product.type == 'agent extend'"
                >
                  <div class="form-group col-12">
                    <input
                      type="text"
                      class="form-control"
                      :readonly="!$isAllowed('changePackageId')"
                      v-model="product.agentPackageId"
                    />
                    <label>Agent Package ID</label>
                  </div>
                </div>
                <div class="form-row" v-if="product.type == 'office'">
                  <div class="form-group col-12">
                    <input
                      type="text"
                      class="form-control"
                      :readonly="!$isAllowed('changePackageId')"
                      v-model="product.officePackageId"
                    />
                    <label>Office Package ID</label>
                  </div>
                </div>
                <div class="form-row" v-if="product.enableJustSold">
                  <div class="form-group col-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="product.justSoldPackageId"
                    />
                    <label>Just Sold Package ID</label>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <textarea class="form-control" v-model="product.description"></textarea>
                    <label>Package description</label>
                  </div>
                </div>
                <div
                  class="form-row"
                  v-if="product.type == 'property' || product.type == 'agent extend'"
                >
                  <div class="form-group col-12">
                    <input type="text" class="form-control" v-model="product.propertyDuration" />
                    <label>Property Duration</label>
                  </div>
                </div>
                <div
                  class="form-row"
                  v-if="product.type == 'agent' || product.type == 'agent extend'"
                >
                  <div class="form-group col-12">
                    <input type="text" class="form-control" v-model="product.agentDuration" />
                    <label>Agent Duration</label>
                  </div>
                </div>
                <div class="form-row" v-if="product.type == 'office'">
                  <div class="form-group col-12">
                    <input type="text" class="form-control" v-model="product.officeDuration" />
                    <label>Office Duration</label>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12 input-icon">
                    <input
                      type="text"
                      name=""
                      value=""
                      class="form-control"
                      v-model="product.retailPrice"
                    />
                    <i>$</i>
                    <label>Retail Price (Vendor Price) excl GST</label>
                  </div>
                  <div class="form-group col-12 input-icon">
                    <input
                      type="text"
                      name=""
                      value=""
                      class="form-control"
                      v-model="product.packagePrice"
                    />
                    <i>$</i>
                    <label>Package Price (Client Price) excl GST</label>
                  </div>
                  <div class="form-group col-12 input-icon">
                    <input
                      type="text"
                      name=""
                      value=""
                      class="form-control"
                      v-model="product.productionFee"
                    />
                    <i>$</i>
                    <label>Production Fee</label>
                  </div>
                  <div class="form-group col-12 input-icon" v-if="$isAllowed('changeTtbCharge')">
                    <input
                      type="text"
                      name=""
                      value=""
                      class="form-control"
                      v-model="product.ttbCharge"
                    />
                    <i>$</i>
                    <label>TTB Charge</label>
                  </div>
                  <div class="form-group col-12 input-icon">
                    <input
                      type="text"
                      name=""
                      value=""
                      class="form-control"
                      v-model="product.sortOrder"
                    />
                    <label>Sort Order</label>
                  </div>
                  <div class="form-group col-12">
                    <div class="c__checkbox inline">
                      <input
                        type="checkbox"
                        name=""
                        value="1"
                        class="form-control"
                        v-model="product.videoRequired"
                      />
                      <label class="">Video Required</label>
                    </div>
                  </div>
                  <div class="form-group col-12">
                    <div class="c__checkbox inline">
                      <input
                        type="checkbox"
                        name=""
                        value="1"
                        class="form-control"
                        v-model="product.pmpRequired"
                      />
                      <label class="">PMP Required</label>
                    </div>
                  </div>
                  <div class="form-group col-12">
                    <div class="c__checkbox inline">
                      <input
                        type="checkbox"
                        name=""
                        value="1"
                        class="form-control"
                        v-model="product.enablePostcodeTargeting"
                      />
                      <label class="">Enable Postcode Targeting</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'tab2'">
            <div class="form-row">
              <div class="col-12">
                <div class="space-between">
                  <div></div>
                  <form id="client-search" class="search-form campaigns-client-search">
                    <input
                      class="form-control"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      v-model="search"
                    />
                  </form>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <div v-if="filteredClients">
                    <label style="margin-bottom:10px">Clients</label>
                    <div v-for="client in filteredClients" :key="client.id">
                      <div class="c__checkbox">
                        <input
                          type="checkbox"
                          v-bind:checked="client.attached"
                          @change="addClient(client)"
                        />
                        <label>{{ client.title }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <div v-if="filteredAgencies">
                    <label style="margin-bottom:10px">Offices</label>
                    <div v-for="agency in filteredAgencies" :key="agency.id">
                      <div class="c__checkbox">
                        <input
                          type="checkbox"
                          v-bind:checked="agency.attached"
                          @change="addAgency(agency)"
                        />
                        <label>{{ agency.displayName }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="c__btn--container">
            <button
              type="button"
              class="btn btn-tertiary"
              v-if="packageId"
              @click="deleteAction(`Are you sure you want to archive ${product.title}?`, 'Archive')"
              :disabled="formState.$invalid || inProgressCampaigns.length > 0"
            >
              Archive
            </button>
          </div>
          <template>
            <div class="c__btn--container">
              <button
                class="btn btn-primary"
                @click="savePackage('published')"
                :disabled="formState.$invalid"
                type="submit"
              >
                Save
              </button>
            </div>
          </template>
        </div>
      </vue-form>
      <result-message :errors="errors"></result-message>
    </template>
  </modal>
</template>

<script>
import Tabs from "vue-tabs-with-active-line";
import Modal from "../../helpers/Modal";
import CloseButton from "../../helpers/CloseButton";
import ResultMessage from "../../helpers/ResultMessage";

import PackagePerimeters from "../../configs/Perimeters/packages";

import PackageServices from "../../services/packages";
import AgencyServices from "../../services/agencies";
import ClientServices from "../../services/clients";
import DeleteAction from "../../mixins/DeleteAction";

export default {
  perimeters: [PackagePerimeters],
  mixins: [DeleteAction],
  name: "ModalPackage",
  props: {
    packageId: {
      default: null
    }
  },
  components: {
    Tabs,
    ResultMessage,
    Modal,
    CloseButton
  },
  computed: {
    filteredAgencies: function() {
      return this.agencies.filter(agency => {
        return agency.displayName.toLowerCase().match(this.search.toLowerCase());
      });
    },
    filteredClients: function() {
      return this.clients.filter(client => {
        return client.title.toLowerCase().match(this.search.toLowerCase());
      });
    },
    inProgressCampaigns: function() {
      if (this.product.campaigns) {
        return this.product.campaigns.data.filter(campaign => {
          return campaign.status === "In Progress";
        });
      }
      return [];
    }
  },
  data() {
    return {
      search: "",
      errors: {
        type: Object | Error,
        $clean: true
      },
      formState: {},
      currentTab: "tab1",
      tabs: [
        {
          title: "Details",
          value: "tab1"
        },
        {
          title: "Client / Offices",
          value: "tab2"
        }
      ],
      created: false,
      product: {},
      agencies: [],
      clients: []
    };
  },
  watch: {
    "product.type"(val) {
      if (val !== "property") {
        this.product.enableJustSold = false;
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    getPackage(packageId) {
      PackageServices.getPackage(packageId, "agencies,clients,campaigns").then(product => {
        this.product = product;
        this.getAgencies("published");
        this.getClients("published");
      });
    },
    addAgency(agency) {
      PackageServices.updatePackageAgencyPermission(this.product, agency).then(result => {
        this.getPackage(this.product.id);
      });
    },
    addClient(client) {
      PackageServices.updatePackageClientPermission(this.product, client).then(result => {
        this.getPackage(this.product.id);
      });
    },
    updatePackage() {
      PackageServices.updatePackage(this.product)
        .then(product => {
          this.product = product;
          this.$emit("closeModal");
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    createPackage() {
      PackageServices.createPackage(this.product)
        .then(product => {
          this.product = product;
          this.created = true;

          this.tabs[1].disabled = false;
          this.currentTab = "tab2";

          this.getAgencies("published");
          this.getClients("published");
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    getAgencies(status) {
      AgencyServices.getAgencies(status, "", "", null, null, -1).then(agencies => {
        this.agencies = agencies.data;
        let vue = this;
        this.agencies.forEach(function(agency) {
          if (vue.product.agencies) {
            vue.product.agencies.data.forEach(function(productAgency) {
              if (agency.id === productAgency.id) {
                agency.attached = true;
              }
            });
          }
        });
      });
    },
    getClients(status) {
      ClientServices.getClients(status).then(clients => {
        this.clients = clients.data;
        let vue = this;
        this.clients.forEach(function(client) {
          if (vue.product.clients) {
            vue.product.clients.data.forEach(function(productClient) {
              if (client.id === productClient.id) {
                client.attached = true;
              }
            });
          }
        });
      });
    },
    savePackage(status) {
      if (this.product.type != "property" && this.product.type != "agent extend") {
        this.product.propertyDuration = null;
      }
      if (this.product.type != "agent" && this.product.type != "agent extend") {
        this.product.agentDuration = null;
      }
      if (this.product.type != "office") {
        this.product.officeDuration = null;
      }
      this.product.status = status;
      if (!this.packageId && !this.created) {
        this.createPackage();
      } else {
        this.updatePackage();
      }
    },
    /**
     * A wrapper around the saveAgency() function to accommodate the
     * DeleteAction mixin callback.
     */
    deleteItem() {
      this.savePackage("archive");
    }
  },
  created() {
    if (this.packageId) {
      this.getPackage(this.packageId);
    } else {
      this.tabs[1].disabled = true;
    }
  },
  mounted() {}
};
</script>
